// @ts-nocheck
import React, { FC, ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import HeaderBrand from './HeaderBrand';
import { getTrialDaysRemaining } from '../../utils/trial.helper';
import ExtendTrial from './ExtendTrial';

type PrimaryActionType = {
  content: string;
  onClick: () => void;
};

type HeaderProps = {
  brand: () => ReactNode;
  search?: ReactNode;
  shop_id?: string;
  primaryAction?: PrimaryActionType;
};

const ExistingShopHeader: FC<HeaderProps> = ({
  brand,
  search,
  shop_id,
  primaryAction,
}) => {
  const [activeBilling, setActiveBilling] = React.useState(null);

  useEffect(() => {
    let current = true;
    const controller = new AbortController();
    setActiveBilling(null);
    fetch(`/api/billings/active/${shop_id}`, {
      method: 'GET',
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        let json_data = JSON.parse(data);
        if (current) {
          setActiveBilling(json_data?.data?.appInstallation?.activeSubscriptions?.[0]);
        }
      })
      .catch((error) => {
        if (current && error.name !== 'AbortError') {
          console.error('Error fetching active billing:', error);
        }
      });
    return () => {
      current = false;
      controller.abort();
    };
  }, [shop_id]);

  const renderPrimaryAction = () => (
    <>
      {primaryAction && (
        <s-button variant='primary' onClick={primaryAction.onClick}>
          {primaryAction.content}
        </s-button>
      )}
    </>
  );

  const renderBillingInfo = () => {
    if (activeBilling) {
      let planName = activeBilling?.name;
      let planPrice = activeBilling?.lineItems?.[0]?.plan?.pricingDetails?.price?.amount;
      let trialDaysRemaining = getTrialDaysRemaining(activeBilling?.trialDays, activeBilling?.createdAt);
      let priceAfterDiscount = activeBilling?.lineItems?.[0]?.plan?.pricingDetails?.discount?.priceAfterDiscount?.amount;
      let trialText = trialDaysRemaining === null
        ? ''
        : trialDaysRemaining > 0
          ? ` | ${trialDaysRemaining} trial ${trialDaysRemaining === 1 ? 'day' : 'days'} remaining`
          : ' | Trial ended';

      return (
        <BillingLine>
          <span>
            {planName} ({planPrice} {priceAfterDiscount ? `- ${priceAfterDiscount} after discount` : ''}){trialText}
          </span>
          {shop_id && trialDaysRemaining > 0 && (
            <ExtendTrial
              shopId={shop_id}
              daysRemaining={trialDaysRemaining}
              onExtended={(subscription) => setActiveBilling((current) => current && current.id === subscription.id
                ? { ...current, trialDays: subscription.trialDays, createdAt: subscription.createdAt }
                : current)}
            />
          )}
        </BillingLine>
      );
    } else {
      return <div>No Active plan</div>;
    }
  }

  return (
    <HeaderContainer>
      <HeaderBrand>{brand()}</HeaderBrand>
      {search}
      <BillingSummary>{renderBillingInfo()}</BillingSummary>
      {renderPrimaryAction()}
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  width: 100%;
  min-height: 64px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #dce1e5;
  > div:first-child { min-width: 0; flex-wrap: wrap; }
  a { overflow-wrap: anywhere; }
`;

const BillingLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 12px;
`;

const BillingSummary = styled.div`
  min-width: 0;
  overflow-wrap: anywhere;
  color: #59636b;
`;

export default ExistingShopHeader;
